var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "#57454A",
    viewBox: "0 0 32 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 3.00004C19.4933 3.00004 22.5067 5.48004 23.1867 8.90671L23.5867 10.9067L25.6267 11.0534C27.7067 11.1867 29.3333 12.9334 29.3333 15C29.3333 17.2 27.5333 19 25.3333 19H8C5.05333 19 2.66667 16.6134 2.66667 13.6667C2.66667 10.9334 4.70667 8.65337 7.41333 8.37337L8.84 8.22671L9.50667 6.96004C10.7733 4.52004 13.2533 3.00004 16 3.00004ZM16 0.333374C12.1467 0.333374 8.8 2.52004 7.13333 5.72004C3.12 6.14671 0 9.54671 0 13.6667C0 18.08 3.58667 21.6667 8 21.6667H25.3333C29.0133 21.6667 32 18.68 32 15C32 11.48 29.2667 8.62671 25.8 8.38671C24.8933 3.78671 20.8533 0.333374 16 0.333374Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCo2);
export default __webpack_public_path__ + "static/media/co2.97784cf4399264357c4ec56a0c2f6229.svg";
export { ForwardRef as ReactComponent };